export class clientProjectSettings {
    constructor(client, project, project_distance, project_shift, project_tag_code) {
        this.client = client;
        this.project = project;
        this.project_distance = project_distance;
        this.project_shift = project_shift;
        this.project_tag_code = project_tag_code;
    }
}